import axios from "axios"
import library from "../../../utils/Library"

export const getNotificationConditionTypeEAuthz = async () => {
  const TOKEN = sessionStorage.getItem("token")
  const URL =
    library.getBaseAPIUrl("e_authz") + "/getNotificationConditionTypeEAuthz"

  return await axios({
    url: URL,
    method: "GET",
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  })
}
